'use client';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Link from '@mui/material/Link';
import { IBARAKI_REGION_ROUTE } from '@/app/ibaraki-region/constants/region';
import { SideBarBox } from '@/components/SideBar/SideBarBox';
import { relativePath } from '@/functions/redirectToRelativePath';

type Props = {
  title: string;
  categories: (CategoryDto & { count: number })[];
  customerSetting: CustomerSetting;
};

export const EventCategory: React.FC<Props> = ({
  title,
  categories,
  customerSetting
}) => {
  return (
    <SideBarBox id="category" title={title}>
      {categories.map((category) => {
        return (
          <Box key={`category-count-${category.id}`}>
            <Box sx={{ my: 1 }}>
              <Link
                color="primary"
                underline="hover"
                href={relativePath(
                  `/${customerSetting.domain}/list/?category=${category.id}#events`,
                  IBARAKI_REGION_ROUTE
                )}
              >
                {category.name} ({category.count})
              </Link>
            </Box>
            <Divider />
          </Box>
        );
      })}
    </SideBarBox>
  );
};
